import React from "react";
import { Link } from 'react-router-dom';
import logo from "../images/logo2.png"
import NavServiceDrop from "../NavServiceDrop/NavServiceDrop";
import NavUserIcon from "../NavUserIcon/NavUserIcon";
import "./Nav.css"
const Nav = () => {
  return ( 
    <header className="header">

      <nav className="Nav">

        <div className="Nav__booking-links" >

          <li><Link to="/"><img className="Nav-logo" src={logo} alt="" srcSet="Bike and logo" /></Link></li>
          {/* <input id="search" type="text" placeholder="Search.."></input> */}
          <NavServiceDrop/>
          
          <li className="Faqs"><Link to="/Faqs">FAQ's</Link></li>

        </div>

        <div className="Nav__booking-signup">

          <li className="BookingLi"><Link to="/Booking">Book Now</Link></li>
          <NavUserIcon/>

        </div>

      </nav>

    </header>

   );
}
 
export default Nav;